/**
 * Enum values for the current action state of of cases table.
 */
export enum TableState {
  IMPORTING = 'importing',
  EXPORTING = 'exporting',
  VIEWING = 'viewing',
}
